(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["membership-plans"] && !Shopify.designMode) return;
  try {
    
  // Click a shirt image to expand it (shared lightbox).
  function mplansOpenLightbox(src) {
    if (!src) return;
    var ov = document.getElementById('mplans-lightbox');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'mplans-lightbox';
      ov.className = 'mplans-lightbox';
      ov.appendChild(document.createElement('img'));
      ov.addEventListener('click', function () { ov.style.display = 'none'; });
      document.body.appendChild(ov);
    }
    ov.querySelector('img').src = src;
    ov.style.display = 'flex';
  }

  // Tee-tier cards: load this year's shirts and require a pick before subscribing.
  document.querySelectorAll('.mplans-form[data-requires-tee="true"]').forEach(function (form) {
    var grid = form.querySelector('[data-mplans-tee-grid]');
    var vInput = form.querySelector('[data-mplans-tee-variant]');
    var dInput = form.querySelector('[data-mplans-tee-display]');
    var btn = form.querySelector('button[type="submit"]');

    function choose(variantId, label, btnEl) {
      form.querySelectorAll('.mplans-tee-size').forEach(function (el) {
        el.setAttribute('aria-pressed', 'false');
      });
      btnEl.setAttribute('aria-pressed', 'true');
      vInput.value = variantId; vInput.disabled = false;
      dInput.value = label; dInput.disabled = false;
      btn.disabled = false;
    }

    fetch('/apps/subscriptions/tees', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { choices: [] }; })
      .then(function (data) {
        var choices = (data && data.choices) || [];
        if (!choices.length) {
          grid.innerHTML = '<span class="mplans-tee-note">Shirts available to choose soon.</span>';
          return;
        }
        grid.innerHTML = '';
        // Dropdown to pick the shirt → its image → its sizes (not all stacked).
        var select = document.createElement('select');
        select.className = 'mplans-tee-select';
        choices.forEach(function (t, i) {
          var o = document.createElement('option');
          o.value = String(i);
          o.textContent = t.title;
          select.appendChild(o);
        });
        var img = document.createElement('img');
        img.className = 'mplans-tee-img';
        img.alt = '';
        img.title = 'Click to expand';
        img.addEventListener('click', function () { mplansOpenLightbox(img.src); });
        var sizes = document.createElement('div');
        sizes.className = 'mplans-tee-sizes';

        function show(i) {
          var t = choices[i];
          if (t.image) { img.src = t.image; img.style.display = 'block'; } else { img.style.display = 'none'; }
          sizes.innerHTML = '';
          (t.variants || []).forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'mplans-tee-size';
            b.textContent = v.size;
            b.setAttribute('aria-pressed', 'false');
            b.addEventListener('click', function () { choose(v.variantId, t.title + ' — ' + v.size, b); });
            sizes.appendChild(b);
          });
        }
        select.addEventListener('change', function () {
          // switching shirts clears the prior size pick
          vInput.value = ''; vInput.disabled = true;
          dInput.value = ''; dInput.disabled = true;
          btn.disabled = true;
          show(parseInt(select.value, 10));
        });
        grid.appendChild(select);
        grid.appendChild(img);
        grid.appendChild(sizes);
        show(0);
      })
      .catch(function () {
        grid.innerHTML = '<span class="mplans-tee-note">Couldn\'t load shirts — please refresh.</span>';
      });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.mplans-form[data-direct="true"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error(err.description || err.message || 'Could not add to cart');
          });
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        alert(err && err.message ? err.message : 'Could not add to cart.');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-tshirt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mtee]');
    if (!root) return;
    var grid = root.querySelector('[data-mtee-grid]');
    var statusEl = root.querySelector('[data-mtee-status]');
    var BASE = '/apps/subscriptions/tshirt';

    // Click a shirt image to expand it (shared lightbox).
    function openLightbox(src) {
      if (!src) return;
      var ov = document.getElementById('mtee-lightbox');
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'mtee-lightbox';
        ov.className = 'mtee-lightbox';
        ov.appendChild(document.createElement('img'));
        ov.addEventListener('click', function () { ov.style.display = 'none'; });
        document.body.appendChild(ov);
      }
      ov.querySelector('img').src = src;
      ov.style.display = 'flex';
    }

    function setStatus(msg, kind) {
      statusEl.textContent = msg;
      statusEl.className = 'mtee-status ' + (kind === 'ok' ? 'mtee-status--ok' : 'mtee-status--warn');
      statusEl.hidden = false;
    }

    function render(state) {
      // Only tee-tier members see this section.
      if (!state || state.tier !== 'tshirt') return;
      root.hidden = false;

      var sel = state.currentSelection;
      if (sel) setStatus('Your pick: ' + sel.title + ' — size ' + sel.size + '. Change it anytime before the next drop.', 'ok');
      else setStatus("You haven't picked a shirt yet.", 'warn');

      var choices = state.choices || [];
      if (!choices.length) {
        grid.innerHTML = '<p style="color:#888;font-size:14px">This year\'s t-shirts aren\'t available to choose yet — check back soon.</p>';
        return;
      }

      grid.innerHTML = '';
      // Dropdown to pick the shirt → its image → its sizes (not all stacked).
      var select = document.createElement('select');
      select.className = 'mtee-select';
      choices.forEach(function (t, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = t.title;
        select.appendChild(o);
      });
      var img = document.createElement('img');
      img.className = 'mtee-img-large';
      img.alt = '';
      img.title = 'Click to expand';
      img.addEventListener('click', function () { openLightbox(img.src); });
      var sizes = document.createElement('div');
      sizes.className = 'mtee-sizes';

      function show(i) {
        var t = choices[i];
        if (t.image) { img.src = t.image; img.style.display = 'block'; } else { img.style.display = 'none'; }
        sizes.innerHTML = '';
        (t.variants || []).forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mtee-size';
          b.textContent = v.size;
          b.setAttribute('aria-pressed', sel && sel.variantId === v.variantId ? 'true' : 'false');
          b.addEventListener('click', function () { choose(v.variantId, b); });
          sizes.appendChild(b);
        });
      }
      select.addEventListener('change', function () { show(parseInt(select.value, 10)); });
      grid.appendChild(select);
      grid.appendChild(img);
      grid.appendChild(sizes);

      // Default to the saved shirt if any, else the first.
      var startIdx = 0;
      if (sel) { for (var j = 0; j < choices.length; j++) { if (choices[j].productId === sel.productId) { startIdx = j; break; } } }
      select.value = String(startIdx);
      show(startIdx);
    }

    function choose(variantId, btn) {
      btn.disabled = true;
      fetch(BASE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantId: variantId })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { setStatus(res.d && res.d.error ? res.d.error : 'Could not save your pick.', 'warn'); return; }
          // Reflect the new selection.
          root.querySelectorAll('.mtee-size').forEach(function (el) { el.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          var s = res.d.selection;
          if (s) setStatus('Your pick: ' + s.title + ' — size ' + s.size + '. Change it anytime before the next drop.', 'ok');
        })
        .catch(function () { btn.disabled = false; setStatus('Could not reach the subscription service.', 'warn'); });
    }

    fetch(BASE, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(render)
      .catch(function () { /* stay hidden */ });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preloader"]) return;
  try {
    
  $(window).on('load', function() { // makes sure the whole site is loaded 
  $('#status').fadeOut(); // will first fade out the loading animation 
  $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website. 
  $('body').delay(350).css({'overflow':'visible'});
})

  } catch(e) { console.error(e); }
})();
})();
